import { Input } from "antd";
import { useEffect } from "react";
import "./CrrBasicInputStyles.scss";

export default function CrrTextInput(props) {
  const {
    qnId = "", //to check if the page using the component is pre-assessment
    selectField,
    question = "",
    placeholderText,
    onChange = "",
    setValue,
    disabled,
    defaultValue,
    answer,
    form,
    unit,
    setselectField,
    value,
    onBlur = () => {},
  } = props;

  const formatResponse = (value) => {
    return { question_id: qnId, text_answer: value };
  };

  useEffect(() => {
    setValue(defaultValue || answer?.text_answer);
  }, [defaultValue]);

  useEffect(() => {
    if (answer) {
      form.setFieldsValue({
        [qnId]: answer?.text_answer,
      });
      setValue(answer?.text_answer);
    }
  }, []);

  const onInputChange = (e) => {
    setValue(e.target.value);
  };
  const onInputBlur = () => {
    if (onChange && value) {
      if (qnId) {
        onChange(formatResponse(form.getFieldValue(qnId) || value));
      } else {
        onChange(value);
      }
    }
    onBlur();
  };

  return (
    <Input
      className="login-input"
      placeholder={!selectField && placeholderText}
      bordered={false}
      onChange={onInputChange}
      onBlur={onInputBlur}
      onFocus={() => setselectField(true)}
      disabled={disabled}
      value={value}
      addonAfter={unit}
    />
  );
}
